/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespAppliedFilters_viewer = {|
  +isSbSharedRefineMenuSearchWithinEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespAppliedFilters_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSbSharedRefineMenuSearchWithinEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
